import React from 'react';
import Button from '@material-ui/core/Button';
import cn from 'classnames';

import styles from '../styles/main/main.module.scss';
import Tooltip from '../../../tooltip';
import WithdrawCountdown from '../../../withdraw-countdown';
import PropTypes from 'prop-types';

const Section = ({
  label,
  token,
  isDisabled,
  buttonClick,
  date,
  onDone,
  textButton,
  tooltipText,
}) => {
  return (
    <>
      <Tooltip className={styles.unstakeTooltip} label={label} text={tooltipText} />
      <div className={styles.unstakeControls}>
        <div className={styles.unstakeControlsText}>
          <div className={cn(styles.unstakeControlValue, styles.active)}>
            <span>{token}</span>
          </div>
          {date ? (
            <div className={styles.unstakeControlDays}>
              <WithdrawCountdown date={date} onDone={onDone} />
            </div>
          ) : null}
        </div>
        <Button
          className={styles.secondaryButton}
          disabled={isDisabled}
          onClick={buttonClick}
          variant='outlined'
        >
          {textButton}
        </Button>
      </div>
    </>
  );
};

Section.propTypes = {
  label: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  buttonClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  date: PropTypes.number,
  textButton: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  onDone: PropTypes.func,
};

Section.defaultProps = {
  isDisabled: false,
};

export default Section;
